import { useDeleteAgentAgentDeleteDeleteMutation } from '@shared/api';

export const useDeleteAgent = (onError?: () => void) => {
  const [deleteAgentMutation, { isLoading }] = useDeleteAgentAgentDeleteDeleteMutation();

  const deleteAgent = async (agentId: number) => {
    try {
      await deleteAgentMutation({
        agentId,
      }).unwrap();
    } catch {
      onError?.();

      throw new Error();
    }
  };

  return { deleteAgent, isLoading };
};
